import { noterAdresse } from '../navigation/adresse-courante.js'

/**
 * COMPTABILITÉ — L'ÉTAT D'UN ÉCRAN, ÉCRIT DANS SON ADRESSE.
 *
 * Un filtre, un onglet, une année, une remise ouverte ne sont pas des pages.
 * L'adresse les porte quand même : un Retour depuis la page suivante les
 * retrouve, un lien envoyé à un collègue rouvre le même écran. Mais l'entrée
 * d'historique est REMPLACÉE, jamais empilée : le Retour quitte l'écran en un
 * clic au lieu de défaire les filtres un par un.
 *
 * ═══ POURQUOI PAS `redirect()` DU ROUTEUR ═══
 * `redirect` est fait pour une adresse qui CHANGE DE CHEMIN (un ancien lien
 * qu'on réécrit) : il marque la navigation comme un remplacement. Le cadre de
 * l'application lit cette marque pour décider du défilement — en haut après
 * un lien, à la position retrouvée après un Retour — mais il la lit APRÈS le
 * montage de la page (les effets d'un enfant passent avant ceux du parent).
 * Or ces écrans réécrivent leur adresse dès le montage (`?depuis=` des
 * Clôtures, `?annee=` de l'annuel, `?vue=&date=` du chiffre d'affaires) :
 * marquée « remplacement », l'arrivée ne remontait plus en haut, et la liste
 * des clôtures, ouverte depuis le bas de l'accueil, s'affichait défilée à
 * mi-hauteur.
 *
 * Ici seul le paramètre change. Le chemin, que le routeur suit, ne bouge
 * pas : le routeur n'a rien à apprendre, et l'état d'historique (la
 * profondeur `lcIdx` dont dépend le Retour) est recopié tel quel.
 *
 * Si l'adresse n'est déjà plus celle de l'écran — une navigation vient de
 * partir — on ne touche à rien : réécrire ramènerait l'utilisateur en arrière.
 *
 * L'adresse complète est NOTÉE (`adresse-courante.ts`) : si une garde refuse
 * ensuite un Retour, le routeur remet celle-ci, paramètres compris, et non le
 * seul chemin.
 *
 * Module sans React ni feuille de style : il se teste hors navigateur avec un
 * `window` de substitution.
 */
export function remplacerRecherche(chemin: string, params: URLSearchParams): void {
  if (window.location.pathname !== chemin) return
  const suite = params.toString()
  const recherche = suite ? `?${suite}` : ''
  if (window.location.search === recherche) return
  window.history.replaceState(window.history.state, '', `${chemin}${recherche}`)
  noterAdresse(`${chemin}${recherche}`)
}
